import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=6d0d116f"
import script from "./UpgradeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports